import {ArrowRight} from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Section } from "./Section";

export function HeroSection({ t }: any) {
    const navigate = useNavigate();
    return (
        <Section className="hero">
            <h1>{t.heroTitle}</h1>
            <p>{t.heroDesc}</p>
            <button onClick={()=> navigate("/contact")} className="cta">
                {t.cta} <ArrowRight size={18} style={{ marginLeft: '8px' }} />
            </button>
        </Section>
    );
}